import React, { Component } from "react";
import Slider from "react-slick";
import KidItem from "../kid-item";
import { Grid } from "@material-ui/core";
import ListDisplayStyle from "./ListDisplayStyle";
import { withStyles } from "@material-ui/styles";
import jQuery from "jquery";
import Classnames from "classnames";
import DotLoader from "react-spinners/DotLoader";
import { css } from "@emotion/core";

import _ from "lodash";
window.jQuery = jQuery;

const override = css`
  display: block;
  margin: 0 auto;
  border-color: red;
`;

function imagesLoaded(parentNode) {
  const imgElements = parentNode.querySelectorAll("img");
  for (const img of imgElements) {
    if (!img.complete) {
      return false;
    }
  }
  return true;
}

class ListDisplay extends Component {
  constructor(props) {
    super(props);
    this.state = {
      counter: 0,
    };
  }

  render() {
    jQuery.ready(function() {});

    const { kids, filterStatus, classes } = this.props;
    const options = {
      className: "cards-carousel",
      adaptiveHeight: false,
      dots: true,
      infinite: true,
      arrows: false,
      speed: 500,
      marginRight: 2,
      slidesToShow: 1,
      currentSlide: 0,
      slidesToScroll: 1,
      rows: 2,
      slidesPerRow: 4,
      initialSlide: 0,
    };

    var divStyle1 = {
      margin: "10px",
    };

    if (!_.isEmpty(kids)) {
      return (
        <>
          <DotLoader
            size={100}
            color={"#ff7d26"}
            css={override}
            loading={this.props.isLoading}
          />
          <div
            style={{ height: "470px" }}
            className={Classnames("container p-0", {
              "d-none": this.props.isLoading,
            })}
          >
            <Slider
              className="myCarousel"
              ref={(element) => {
                this.carouselElement = element;
              }}
              {...options}
              style={divStyle1}
            >
              {kids.map((kidId) => (
                <Grid key={kidId} item xs={3}>
                  <KidItem
                    kid={this.props.kidsById[kidId]}
                    editEnfant={this.props.editEnfant}
                    openFicheEnfant={this.props.openFicheEnfant}
                    onOpenModaleNotifications={
                      this.props.onOpenModaleNotifications
                    }
                    onCloseModaleNotifications={
                      this.props.onCloseModaleNotifications
                    }
                  />
                </Grid>
              ))}
            </Slider>
          </div>
        </>
      );
    } else {
      return (
        <div
          style={{ height: "470px" }}
          className={Classnames("container p-0")}
        ></div>
      );
    }
  }
}

export default withStyles(ListDisplayStyle)(ListDisplay);
